import { useNavigate } from "react-router-dom";
import PublicNav from "../components/PublicNav";

export default function PrivacyPage() {
  const navigate = useNavigate();

  const sections = [
    {
      title: "What we collect",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          Band OS collects the information you provide when creating an account:
          your display name, email address, and band name. If you upload sheet
          music, the PDF files are stored on your behalf. Payment information is
          handled entirely by Stripe — we never see or store your card details.
        </p>
      ),
    },
    {
      title: "How we use it",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          Your information is used solely to provide the Band OS service:
          authenticating your account, storing your band's song library and
          setlists, and processing subscription payments. We do not sell, rent,
          or share your data with third parties for marketing purposes.
        </p>
      ),
    },
    {
      title: "Data storage",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          Your account data is stored in Google Firebase (Firestore and Firebase
          Authentication), hosted in the United States. Sheet music PDFs are
          stored in Firebase Storage. Stripe stores payment and subscription data
          on their infrastructure subject to their own privacy policy.
        </p>
      ),
    },
    {
      title: "Data retention",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          Your data is retained for as long as your account is active. You can
          delete your account at any time directly from the app — open the
          Members tab and scroll to the Danger zone section. Deleting your
          account permanently removes your profile, songs, setlists, and
          membership records. This action cannot be undone.
        </p>
      ),
    },
    {
      title: "Cookies",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          Band OS uses Firebase Authentication session tokens stored in your
          browser to keep you signed in. We do not use third-party tracking
          cookies or advertising cookies.
        </p>
      ),
    },
    {
      title: "Contact",
      body: (
        <p className="text-text-secondary text-[0.95rem] leading-[1.8]">
          Questions about this policy? Email us at:{" "}
          <a
            href="mailto:privacy@bandos.app"
            className="text-brand-gold hover:text-brand-gold/80 underline"
          >
            privacy@bandos.app
          </a>
        </p>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-base font-sans">
      <PublicNav bandId={null} onHome={() => navigate("/")} />

      <div className="max-w-2xl mx-auto px-6 py-16">
        <button
          onClick={() => navigate("/")}
          className="text-text-muted hover:text-text-primary text-sm bg-transparent border-0 p-0 mb-8 flex items-center gap-1.5 cursor-pointer transition-colors"
        >
          ← Back
        </button>

        <p className="text-brand-gold text-xs font-medium tracking-[0.2em] uppercase mb-3">
          Legal
        </p>
        <h1 className="font-display text-3xl text-text-primary mb-3">
          Privacy Policy
        </h1>
        <p className="text-text-muted text-sm">Last updated: April 2025</p>

        {sections.map((section, i) => (
          <section
            key={section.title}
            className={
              i === 0
                ? "mt-10"
                : "border-t border-white/[0.06] mt-10 pt-10"
            }
          >
            <h2 className="text-text-primary text-lg font-medium mt-10 mb-3">
              {section.title}
            </h2>
            {section.body}
          </section>
        ))}
      </div>
    </div>
  );
}
